import store from '@/store';

export function homeRoute() {
  const hasPermission = store.getters['timeTracker/hasPermission'];

  if (hasPermission('view_all_employees')) {
    return { name: 'tt-dashboard' };
  }

  if (store.getters['timeTracker/hasAnyAdminAccess']) {
    if (hasPermission('manage_bonuses')) return { name: 'tt-bonuses' };
    if (hasPermission('view_payroll')) return { name: 'tt-payroll' };
    return { name: 'tt-account' };
  }

  return { name: 'tt-my-pay' };
}

export async function timeTrackerBeforeEnter(to) {
  // On refresh, guards run before DefaultContainer's pingAuth. If authenticated
  // but user details aren't in memory yet, load them so permission checks below
  // are accurate (cookie persistence can drop large all_permissions payloads).
  const authed = store.getters['timeTracker/isAuthenticated'];
  const user = store.getters.getUserDetails;
  if (authed && (!user || Object.keys(user).length === 0)) {
    await store.dispatch('pingAuth');
  }

  // One shared bootstrap (idempotent) instead of a separate offices fetch that
  // races DefaultContainer / Shell bootstrap.
  if (authed && (to.meta.permission || to.meta.requiresOwner || to.meta.requiresEmployee)) {
    try {
      await store.dispatch('timeTracker/bootstrap');
    } catch (e) {
      // The permission check below will redirect if no TT access is available.
    }
  }

  if (to.meta.requiresOwner && !store.getters['timeTracker/isOwner']) {
    const dest = homeRoute();
    if (dest.name === to.name) return { name: 'tt-account' };
    return dest;
  }

  if (to.meta.permission && !store.getters['timeTracker/hasPermission'](to.meta.permission)) {
    const dest = homeRoute();
    if (dest.name === to.name) return { name: 'tt-account' };
    return dest;
  }

  if (to.meta.requiresEmployee) {
    const me = store.state.timeTracker.me;
    if (me === null) return true;
    if (!me.is_employee) return { name: 'tt-account' };
  }

  return true;
}
